import { render, staticRenderFns } from "./SLAHeatmap.vue?vue&type=template&id=2eaaedee&scoped=true"
import script from "./SLAHeatmap.vue?vue&type=script&lang=js"
export * from "./SLAHeatmap.vue?vue&type=script&lang=js"
import style0 from "./SLAHeatmap.vue?vue&type=style&index=0&id=2eaaedee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaaedee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eaaedee')) {
      api.createRecord('2eaaedee', component.options)
    } else {
      api.reload('2eaaedee', component.options)
    }
    module.hot.accept("./SLAHeatmap.vue?vue&type=template&id=2eaaedee&scoped=true", function () {
      api.rerender('2eaaedee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/SLAHeatmap.vue"
export default component.exports